<div class="fire-instances-container">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>add_alert</mat-icon> Fire safety instances</mat-card-title
    >

    <div class="actions">
      <div
        class="plan-number-vis"
        [style.border-color]="isPlanNumberRevealed ? 'green' : 'red'"
      >
        <mat-icon
          matSuffix
          [style.color]="isPlanNumberRevealed ? 'green' : 'red'"
          class="text-sm"
        >
          {{ isPlanNumberRevealed ? 'visibility' : 'visibility_off' }}
        </mat-icon>
        <p>
          {{
            isPlanNumberRevealed ? 'Plan number visible' : 'Plan number hidden'
          }}
        </p>
      </div>

      <button
        matButton="filled"
        color="primary"
        (click)="backToDashboard()"
        matTooltip="Back to dashboard"
      >
        <mat-icon>keyboard_backspace</mat-icon>
        Back to dashboard
      </button>
    </div>
  </mat-card-header>
  <div class="table-info-widget-container">
    <mat-card class="table-info-widget">
      <div class="date-filter-controls">
        <mat-form-field appearance="fill">
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="startDatePicker"
            [(ngModel)]="startDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>End Date</mat-label>
          <input
            matInput
            [matDatepicker]="endDatePicker"
            [(ngModel)]="endDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <div class="filter-buttons">
          <button
            mat-raised-button
            color="primary"
            (click)="getFireSafetyInstances()"
            matTooltip="Generate chart"
          >
            <mat-icon>filter_list</mat-icon>
            Generate Chart
          </button>

          <button
            mat-stroked-button
            color="accent"
            (click)="clearData()"
            matTooltip="Clear data"
          >
            <mat-icon>clear</mat-icon>
            Clear
          </button>

          <button
            mat-icon-button
            color="primary"
            matTooltip="Refresh data"
            (click)="refreshData()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>

      <mat-card-content>
        @if (totalCount > 0) {
          <div class="info-grid">
            <div class="info-item">
              <mat-icon class="info-icon">list</mat-icon>
              <div class="info-content">
                <span class="info-label">Total Items</span>
                <span class="info-value">{{ totalCount }}</span>
              </div>

              <button
                mat-raised-button
                color="primary"
                (click)="seeFireInstances()"
                [matTooltip]="showItems ? 'Hide instances' : 'Show instances'"
              >
                <p>{{ showItems ? 'Hide instances' : 'Show instances' }}</p>
              </button>
            </div>

            @if (this.isLoading) {
              <mat-progress-spinner
                diameter="50"
                mode="indeterminate"
              ></mat-progress-spinner>
              <span>Loading...</span>
            }

            @if (this.showItems) {
              <table
                mat-table
                [dataSource]="dataSource"
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="planNumber">
                  <th mat-header-cell *matHeaderCellDef>Plan Number</th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      [ngClass]="
                        isPlanNumberRevealed
                          ? 'plan-number-revealed'
                          : 'plan-number-blurred'
                      "
                    >
                      {{ element.planNumber }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatDate(element.sk) }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>

              <mat-paginator
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 25]"
                [style.display]="totalCount > 5 ? '' : 'none'"
                showFirstLastButtons
              ></mat-paginator>
            }
          </div>
        } @else {
          <div class="no-data">
            <mat-icon>info</mat-icon>
            <span>No table information available</span>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
